import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

const useScreenSize = () => {
  const [size, setSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(() => {
      setSize(window.innerWidth);
    }, 500);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return [size];
};

export default useScreenSize;
